import React, { Component } from 'react';
// utils
import { Translations, convertStringToArray } from '../../../../../utils';
// children
import GLSApprover from './GLSApprover';
import Role from './Role';
// style
import './Filter.css';

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputStr: ''
    }
  }
  searchItmeHandler = (event) => {
    this.setState({ inputStr: event.target.value });
    this.props.searchItmeHander(event.target.value);
  }
  getRoleStatusOnchange = (str) => {
    this.setState({ inputStr: '' });
    this.props.getRoleStatusOnchange(str);
  }

  getApproverStatusOnchange = (str) => {
    this.setState({ inputStr: '' });
    this.props.getApproverStatusOnchange(str);
  }

  forceUpdateCustom = () => {
    let _state = this.state;
    _state['inputStr'] = '';
    this.setState(_state);
    this.props.showFilters === true && this.props.glsApprover.length > 0 && this.refs.status._clearStatus();
    this.props.showFilters === true && this.props.role.length > 0 && this.refs.caseowner._clearStatus();
    this.props.showFilters === true && this.props.getApproverStatusOnchange('');
    this.props.showFilters === true && this.props.getRoleStatusOnchange('');
    this.props.clearAll();
  }

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  render() {
    return (
      <div className="gdoc-caselist-filter">
        <ul>
          <li>
            <div className="gdoc-caselist-filter-search searchListform">
              <label className="customerlbl">{this.translations(this.props.serchTitleHeader)}</label>
              <input type="text" maxLength="100" id="searchText" className="form-control form-control-lg" value={this.state.inputStr} onChange={(event) => this.searchItmeHandler(event)} />
              <span className="verticalLine"></span>
              <i className="icon icon-search serachicon"></i>
            </div>
          </li>
          <li>
            {
              this.props.showFilters === true && this.props.role.length > 0
                ? <Role
                  ref="caseowner"
                  caseOwner={this.props.role}
                  heading={this.translateWord(this.props.pageJson.table_adminList.fieldLabels)[1]}
                  getRoleStatusOnchange={(str) => this.getRoleStatusOnchange(str)}
                  text1={this.translations(this.props.pageJson.table_adminList.text1)}
                />
                : ''
            }
            {
              this.props.showFilters === true && this.props.glsApprover.length > 0
                ? <GLSApprover
                  ref="status"
                  caseStatus={this.props.glsApprover}
                  heading={this.translateWord(this.props.pageJson.table_adminList.fieldLabels)[3]}
                  getApproverStatusOnchange={(str) => this.getApproverStatusOnchange(str)}
                  text1={this.translations(this.props.pageJson.table_adminList.text2)}
                />
                : ""
            }
            <span onClick={() => this.forceUpdateCustom()} role="link" tabIndex="0">{this.translations(this.props.clearFilterText)} </span>
          </li>
        </ul>
      </div>
    )
  }
}

Filter.defaultProps = {
  caseStatus: [],
  caseOwner: []
}

Filter.propTypes = {

};

export default Filter;



// WEBPACK FOOTER //
// ./src/components/Admin/AdminPanel/SubComp/Grid/Filter.js